// extracted by mini-css-extract-plugin
module.exports = {"slider":"style_slider__1Hr0Z","img-detail":"style_img-detail__36ly6"};